// extracted by css-extract-rspack-plugin
export default {"root":"uD0jK","wrapper":"F7iIm","icon":"uBDaO","body":"MJEEJ","title":"gRk3W","message":"vE2bG","closeButton":"gUc4T"};